import React from 'react';

import { Radio } from 'antd';

interface IRadioSelectionProps {
  formLabel: string;
  options: {
    value: string;
    label: string;
  }[];
  selectedValue: string;
  handleSelected: (event: any, value: any) => void;
  isDisabled: boolean;
}

const optionsBase =
  'min-h-[38px] text-center grow flex! items-center justify-center cursor-pointer m-0 py-2 transition-all duration-200 ease-in-out bg-[#DDDDDD] [&>span]:text-black [&>span]:font-inherit [&>span]:text-sm [&>span]:leading-none [&>span]:font-normal';
const optionsHover = 'hover:bg-primary! hover:border-primary! [&:hover>span]:text-white';
const optionsSelected = 'bg-primary! border-primary [&>span]:text-white';
const optionsDisabledHover = 'hover:bg-[#DDDDDD]';

function RadioSelection({ formLabel, options, selectedValue, handleSelected, isDisabled }: IRadioSelectionProps) {
  return (
    <div className='font-inherit block'>
      <div className='font-inherit flex justify-between text-sm leading-[150%] font-normal'>
        <p>{formLabel}</p>
      </div>
      <Radio.Group
        className='my-4 flex! w-full flex-row items-center justify-evenly'
        value={selectedValue}
        onChange={e => handleSelected(e, e.target.value)}
        disabled={isDisabled}
      >
        {options.map(option => {
          const isSelected = option.value === selectedValue && !isDisabled;
          return (
            <Radio.Button
              className={`${optionsBase} ${isSelected ? optionsSelected : ''} ${isDisabled ? optionsDisabledHover : optionsHover}`}
              key={option.value}
              id={`radio-option-${option.value}`}
              value={option.value}
            >
              {option.label}
            </Radio.Button>
          );
        })}
      </Radio.Group>
    </div>
  );
}

export default RadioSelection;
